"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _util = require("../../util");
var TotalAmount = function TotalAmount(_ref) {
  var fields = _ref.fields;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-revisor__total-amount"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-revisor__total-amount-label"
  }, "New Plan Total Amount"), /*#__PURE__*/_react.default.createElement("div", {
    className: "revisions-revisor__total-amount-value"
  }, (0, _util.toDollar)((0, _util.totalAmount)(fields))));
};
TotalAmount.propTypes = {
  fields: _propTypes.default.arrayOf(_propTypes.default.object).isRequired
};
var _default = exports.default = TotalAmount;
